import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ConsentService } from '../../common/services/consent.service';
import { WHATS_NEW_ENTRIES } from '../whats-new/whats-new.data';

@Component({
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AboutComponent {
  readonly consent = inject(ConsentService);
  private readonly route = inject(ActivatedRoute);

  /** Tab index: 0 = About, 1 = What's New, 2 = Credits */
  selectedTab = 0;

  constructor() {
    const tab = this.route.snapshot.queryParamMap.get('tab');
    if (tab === 'whats-new') this.selectedTab = 1;
    else if (tab === 'credits') this.selectedTab = 2;
  }

  readonly whatsNewEntries = WHATS_NEW_ENTRIES;
}
